module.exports = __webpack_public_path__ + "img/Progress-Report-Process-1.ce43754d.png";